import type { MessageKey } from "@wato/i18n";

/** OWN-163: the starter questions; each i18n value is the FULL sentence sent to the assistant. */
export const SUGGESTED_QUESTION_KEYS = [
  "dashboard.ownerAssistant.chips.today",
  "dashboard.ownerAssistant.chips.waiting",
  "dashboard.ownerAssistant.chips.team",
  "dashboard.ownerAssistant.chips.questions",
  "dashboard.ownerAssistant.chips.bookings",
  "dashboard.ownerAssistant.chips.store",
] as const satisfies readonly MessageKey[];

/** The four examples shown on the Home card. */
export const HOME_QUESTION_KEYS = [
  "dashboard.ownerAssistant.chips.today",
  "dashboard.ownerAssistant.chips.waiting",
  "dashboard.ownerAssistant.chips.bookings",
  "dashboard.ownerAssistant.chips.store",
] as const satisfies readonly MessageKey[];

/** Ctrl+J / Cmd+J (fires inside inputs too, like Ctrl+K). */
export function isAssistantShortcut(event: {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  altKey: boolean;
  shiftKey: boolean;
}): boolean {
  return (
    event.key.toLowerCase() === "j" &&
    (event.ctrlKey || event.metaKey) &&
    !event.altKey &&
    !event.shiftKey
  );
}

/**
 * Only a workspace-relative path: starts with a single "/", no "//" anywhere, no ".." segments
 * (also percent-encoded), no backslash, no ":" (scheme / port tricks), no whitespace/control chars.
 */
export function safeRelativePath(href: string): string | null {
  if (!href.startsWith("/") || href.includes("//")) return null;
  // eslint-disable-next-line no-control-regex
  if (href.includes("\\") || href.includes(":") || /[\u0000-\u001f\u007f\s]/.test(href))
    return null;
  const pathname = href.split(/[?#]/, 1)[0] ?? "";
  let decoded: string;
  try {
    decoded = decodeURIComponent(pathname);
  } catch {
    return null;
  }
  if (decoded.includes("\\") || decoded.includes("//")) return null;
  if (decoded.split("/").some((seg) => seg === ".." || seg === ".")) return null;
  return href;
}
